import { render, staticRenderFns } from "./ShippingCheckingForm.vue?vue&type=template&id=bec52dce&scoped=true&"
import script from "./ShippingCheckingForm.vue?vue&type=script&lang=js&"
export * from "./ShippingCheckingForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingCheckingForm.vue?vue&type=style&index=0&id=bec52dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec52dce",
  null
  
)

export default component.exports